import React from "react"
import PageTransition from "./src/components/motion/PageTransition"
import "./src/styles/globals.css"

export const wrapPageElement = ({ element, props }) => (
  <PageTransition location={props.location}>{element}</PageTransition>
)

export const onServiceWorkerUpdateReady = () => {
  window.location.reload()
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: "gatsby_route_change",
      page_location: window.location.href,
      page_path: location?.pathname,
      page_title: document.title,
      page_referrer: prevLocation
        ? window.origin + prevLocation.pathname
        : document.referrer || "",
    })
  }
}
